import { render, staticRenderFns } from "./codiciPagamento.vue?vue&type=template&id=d0d03ffc&"
import script from "./codiciPagamento.vue.ts?vue&type=script&lang=ts&"
export * from "./codiciPagamento.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports